import React from 'react';
import TextArea from '../../../forms/TextArea';

const CommentsModalForm = ({ data, onInput }) => (
    <React.Fragment>
        <div className="ckp-admin-grid-column">
            <TextArea
                label="Comments"
                className="is-full-width"
                value={data.comments}
                onChange={onInput}
                disabled={false}
                name="comments"
            />
        </div>
    </React.Fragment>
);

export default CommentsModalForm;
